import ListReportStore from './report.list';
import ReportDetailStore from './report.details';

export const reportStores = {
  list: ListReportStore,
  details: ReportDetailStore
}